export function productCount(value) {
  const count = Number(value);
  const last = count % 10, lastTwo = count % 100;
  const noun = lastTwo >= 11 && lastTwo <= 14 ? 'товарів' : last === 1 ? 'товар' : last >= 2 && last <= 4 ? 'товари' : 'товарів';
  return `${count} ${noun}`;
}
